
import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from '../../utils/api';
import { INotificationResponse, INotificationParams } from './types';

export const fetchNotifications = createAsyncThunk(
  'notifications/fetchNotifications',
  async (params: INotificationParams, { rejectWithValue }) => {
    try {
      const { page, page_size } = params;
      const response = await apiCall<{ data: INotificationResponse }>('get', `/api/notification/list/?page=${page}&page_size=${page_size}`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch notifications');
    }
  }
);

export const markNotificationAsRead = createAsyncThunk(
  'notifications/markNotificationAsRead',
  async (notificationId: number, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; message: string }>('patch', `/api/notification/${notificationId}/read/`);
      return { notificationId, ...response.data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to mark notification as read');
    }
  }
);

export const deleteNotification = createAsyncThunk(
  'notifications/deleteNotification',
  async (notificationId: number, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; message: string }>('delete', `/api/notification/${notificationId}/delete/`);
      return { notificationId, ...response.data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete notification');
    }
  }
);

export const markAllNotificationsAsRead = createAsyncThunk(
  'notifications/markAllNotificationsAsRead',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<{ status: boolean; message: string }>('patch', '/api/notification/mark-all-read/');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to mark all notifications as read');
    }
  }
);
